module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogcmdiYSgyMDYsIDIxMiwgNDQsIDAuNCk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxyZWN0IGlkPSJSZWN0YW5nbGVfNCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNCIgY2xhc3M9ImNscy0xIiB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHJ4PSIxMSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/wl-green-off.svg
// module id = wAfm
// module chunks = 1